import { render, staticRenderFns } from "./JaApexChart.vue?vue&type=template&id=bbff4cda&scoped=true"
import script from "./JaApexChart.vue?vue&type=script&lang=js"
export * from "./JaApexChart.vue?vue&type=script&lang=js"
import style0 from "./JaApexChart.vue?vue&type=style&index=0&id=bbff4cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbff4cda",
  null
  
)

export default component.exports